var module = 'main', name = 'main/assets/svg/close.svg', content = "<?xml version=\"1.0\" encoding=\"utf-8\"?> <svg xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path stroke-linejoin=\"round\" stroke-linecap=\"round\" stroke-width=\"2\" stroke=\"#83827d\" fill=\"none\" fill-rule=\"evenodd\" d=\"M 6.66 1 L 0 7.56 L 6.66 14.12\" transform=\"rotate(180 4 7.56)\"/><path stroke-linejoin=\"round\" stroke-linecap=\"round\" stroke-width=\"2\" stroke=\"#83827d\" fill=\"none\" fill-rule=\"evenodd\" d=\"M 14.66 1 L 8 7.56 L 14.66 14.12\"/></svg>";
angular.module(module).run(['$templateCache', function($templateCache) {
  $templateCache.put(name, content);
}]);
module.exports = name;


//////////////////
// WEBPACK FOOTER
// ./main/assets/svg/close.svg
// module id = 1293
// module chunks = 0